<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
  >
    <g data-name="グループ 12809" transform="translate(22376 17349)">
      <rect
        data-name="長方形 4501"
        :width="width"
        :height="height"
        rx="3"
        transform="translate(-22376 -17349)"
        style="fill: #fff"
      />
      <path
        data-name="パス 4492"
        d="M468.734 253.039a.685.685 0 0 0 .518-.24.739.739 0 0 0-.053-1.018l-4.03-3.744 4.03-3.74a.739.739 0 0 0 .053-1.018.681.681 0 0 0-.983-.056l-4.608 4.277a.741.741 0 0 0 0 1.074l4.608 4.281a.686.686 0 0 0 .465.184z"
        transform="translate(-22827.43 -17587.039)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5099"
        d="M468.734 253.039a.685.685 0 0 0 .518-.24.739.739 0 0 0-.053-1.018l-4.03-3.744 4.03-3.74a.739.739 0 0 0 .053-1.018.681.681 0 0 0-.983-.056l-4.608 4.277a.741.741 0 0 0 0 1.074l4.608 4.281a.686.686 0 0 0 .465.184z"
        transform="translate(-22832.432 -17587.039)"
        :style="{ fill: color }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HelpSVG',
  props: {
    width: {
      type: String,
      default: '26px',
    },
    height: {
      type: String,
      default: '20px',
    },
    viewBox: {
      type: String,
      default: '0 0 26 20',
    },
    color: {
      type: String,
      default: '#989898',
    },
  },
};
</script>
